export default "/images/facebook_footer_logo.png";